import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const SITE_URL = 'https://lifechurchofnj.com';
const SUFFIX = 'Life Church of New Jersey';
const DEFAULT_DESC = 'A Spirit-filled, multicultural church in Laurence Harbor (Old Bridge Township), NJ. Sunday worship at 12 PM. Serving Old Bridge, Matawan, South Amboy and Middlesex County. Plan your visit.';

const ROUTES = {
  '/': { title: 'Church in Old Bridge, NJ | Life Church of New Jersey', desc: DEFAULT_DESC },
  '/what-to-expect': { title: 'What to Expect | Church in Laurence Harbor, NJ', desc: 'First time at Life Church of New Jersey? Service times, kids ministry, what to wear and what a Sunday looks like at our church in Old Bridge Township.' },
  '/plan-your-visit': { title: 'Plan Your Visit | Life Church Old Bridge NJ', desc: "Visiting a church near Old Bridge, Matawan or South Amboy? Let us know you're coming and we'll save you a seat and meet you at the door." },
  '/connect': { title: `Connect | ${SUFFIX}` },
  '/watch-live': { title: `Watch Live | ${SUFFIX}` },
  '/sermons': { title: 'Sermons | Life Church of New Jersey, Old Bridge NJ' },
  '/about': { name: 'About Us' },
  '/beliefs': { name: 'Our Beliefs' },
  '/team': { name: 'Meet the Team' },
  '/team/pastor-andrew': { name: 'Pastor Andrew' },
  '/ministries': { name: 'Ministries' },
  '/ministries/prayer-fasting': { name: 'Prayer & Fasting' },
  '/ministries/restore/safe-church': { name: 'Safe Church' },
  '/bible-study': { name: 'Bible Study' },
  '/pastor-corner': { name: "Pastor's Corner" },
  '/devotional': { name: 'Weekly Devotional' },
  '/conduct': { name: 'Conduct Agreement' },
};

const setMeta = (selector, attr, key, value) => {
  let el = document.head.querySelector(selector);
  if (!el) { el = document.createElement(selector.startsWith('link') ? 'link' : 'meta'); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute(selector.startsWith('link') ? 'href' : 'content', value);
};

export const pageTitle = (name) => `${name} | ${SUFFIX}`;

export const applySeo = ({ title, desc, path, noindex = false }) => {
  if (title) document.title = title;
  setMeta('meta[name="description"]', 'name', 'description', desc || DEFAULT_DESC);
  setMeta('meta[property="og:title"]', 'property', 'og:title', title || document.title);
  setMeta('meta[property="og:description"]', 'property', 'og:description', desc || DEFAULT_DESC);
  setMeta('meta[name="robots"]', 'name', 'robots', noindex ? 'noindex, nofollow' : 'index, follow');
  if (path !== undefined) setMeta('link[rel="canonical"]', 'rel', 'canonical', `${SITE_URL}${path}`);
};

const fallbackName = (path) => {
  const seg = path.split('/').filter(Boolean).pop() || '';
  return seg.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
};

/** Sets per-route <title>, description, canonical and robots on every navigation. */
export const RouteSeo = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
    if (path.startsWith('/admin')) return applySeo({ title: pageTitle('Admin'), path, noindex: true });
    const r = ROUTES[path] || {};
    applySeo({ title: r.title || pageTitle(r.name || fallbackName(path)), desc: r.desc, path });
  }, [pathname]);
  return null;
};

/** Page-level override once dynamic data (ministry name, devotional title) has loaded. */
export const useSeoTitle = (name, desc) => {
  useEffect(() => {
    if (name) applySeo({ title: pageTitle(name), desc });
  }, [name, desc]);
};
